import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import LandscapeApp from './landscape/LandscapeApp'
import PortraitApp from './portrait/PortraitApp'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter as Router } from 'react-router-dom'

ReactDOM.render(
  <Router basename="/">
    {document.documentElement.clientWidth >
    document.documentElement.clientHeight * 1.2 ? (
      <LandscapeApp />
    ) : (
      <PortraitApp />
    )}
  </Router>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
